import {
  Dynamic_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  Dynamic_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD,
  Dynamic_MASSIVE_UPLOAD_REQUEST_VERIFY,
  Dynamic_MASSIVE_UPLOAD_SET_VERIFY,
  Dynamic_MASSIVE_UPLOAD_CLEAR_VERIFY,
  Dynamic_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  Dynamic_MASSIVE_UPLOAD_SET_UPLOAD,
  Dynamic_MASSIVE_UPLOAD_CLEAR_UPLOAD,
  SHOPPING_EXIST_STATEMENTS,
} from '../actions';

function BaseInformationMassiveUploadReducer(state = {}, action) {
  const { type } = action;

  switch (type) {
    case Dynamic_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: action.payload,
      };

    case Dynamic_MASSIVE_UPLOAD_CLEAR_ALLOW_UPLOAD:
      return {
        ...state,
        isLoading: false,
        allowUpload: null,
      };

    case Dynamic_MASSIVE_UPLOAD_REQUEST_VERIFY:
      return {
        ...state,
        isLoading: true,
        verify: null,
      };

    case Dynamic_MASSIVE_UPLOAD_SET_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: action.payload,
      };

    case Dynamic_MASSIVE_UPLOAD_CLEAR_VERIFY:
      return {
        ...state,
        isLoading: false,
        verify: null,
      };

    case Dynamic_MASSIVE_UPLOAD_REQUEST_UPLOAD:
      return {
        ...state,
        isLoading: true,
        upload: null,
      };

    case Dynamic_MASSIVE_UPLOAD_SET_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: action.payload,
      };

    case Dynamic_MASSIVE_UPLOAD_CLEAR_UPLOAD:
      return {
        ...state,
        isLoading: false,
        upload: null,
      };

    case SHOPPING_EXIST_STATEMENTS:
      return {
        ExistsStatements: null,
      };

    default:
      return state;
  }
}

export default BaseInformationMassiveUploadReducer;
